import React from 'react';
import { Localizacion } from "lib.front"
import { endOfMonth, startOfMonth } from "date-fns";

const today = new Date();

export const columns = [
    {
        name: 'producto',
        label: 'Producto',
        options: {
            filter: true,
            sort: true,
            display: true
        },
    },
    {
        name: 'nroSop',
        label: 'Nro de soportes',
        options: {
            filter: true,
            sort: true,
            display: true
        },
    },
    {
        name: 'nroAct',
        label: 'Nro de actualizaciones',
        options: {
            filter: true,
            sort: true,
            display: true
        },
    },
    {
        name: 'nroCap',
        label: 'Nro de capacitaciones',
        options: {
            filter: true,
            sort: true,
            display: true
        },
    },
    {
        name: 'nroIns',
        label: 'Nro de instalaciones',
        options: {
            filter: true,
            sort: true,
            display: true
        },
    },
    {
        name: 'nroAteIni',
        label: 'Nro de atenciones iniciadas',
        options: {
            filter: true,
            sort: true,
            display: true
        },
    },
    {
        name: 'nroAteIni',
        label: 'Nro de atenciones iniciadas',
        options: {
            filter: true,
            sort: true,
            display: true
        },
    },
    {
        name: 'nroAtePro',
        label: 'Nro de atenciones en proceso',
        options: {
            filter: true,
            sort: true,
            display: true
        },
    },
    {
        name: 'nroAteCan',
        label: 'Nro de atenciones canceladas',
        options: {
            filter: true,
            sort: true,
            display: true
        },
    },
];

export const options = {
    filterType: 'dropdown',
      selectableRows: 'none',
      responsive: 'stacked',
      pagination: true,
      elevation: 2,
      rowsPerPage: 3,
      rowsPerPageOptions: [3, 10, 15, 100],
      rowHover: false,
      search: true,
      print: false,
      download: false,
      viewColumns: true,
      textLabels: Localizacion.muiDataTables.ES
};

export const filtrosIniciales = {
    cliente: null,
    fechaInicio: startOfMonth(today),
    fechaFin: endOfMonth(today)
};